import { jsxs as r, jsx as C } from "react/jsx-runtime";
const t = ({ className: l, width: e = "18", height: o = "18" }) => /* @__PURE__ */ r(
  "svg",
  {
    className: l,
    width: e,
    height: o,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 18 18",
    fill: "none",
    children: [
      /* @__PURE__ */ C("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M2.625 3.1875C2.625 2.87684 2.87684 2.625 3.1875 2.625H8.25V4.6875C8.25 5.61948 9.00552 6.375 9.9375 6.375H12V8.25C12 8.56066 12.2518 8.8125 12.5625 8.8125C12.8732 8.8125 13.125 8.56066 13.125 8.25V5.8125C13.125 5.42321 12.9704 5.04986 12.6951 4.77459L9.85041 1.92992C9.57514 1.65465 9.20179 1.5 8.8125 1.5H3.1875C2.25552 1.5 1.5 2.25552 1.5 3.1875L1.5 15C1.5 15.932 2.25552 16.6875 3.1875 16.6875H7.3125C7.62316 16.6875 7.875 16.4357 7.875 16.125C7.875 15.8143 7.62316 15.5625 7.3125 15.5625H3.1875C2.87684 15.5625 2.625 15.3107 2.625 15L2.625 3.1875ZM9.375 4.6875V3.04549L11.5795 5.25H9.9375C9.62684 5.25 9.375 4.99816 9.375 4.6875Z", fill: "currentColor" }),
      /* @__PURE__ */ C("path", { d: "M12.5625 10.3125C12.8732 10.3125 13.125 10.5643 13.125 10.875V12.9375H15.1875C15.4982 12.9375 15.75 13.1893 15.75 13.5C15.75 13.8107 15.4982 14.0625 15.1875 14.0625H13.125V16.125C13.125 16.4357 12.8732 16.6875 12.5625 16.6875C12.2518 16.6875 12 16.4357 12 16.125V14.0625H9.9375C9.62684 14.0625 9.375 13.8107 9.375 13.5C9.375 13.1893 9.62684 12.9375 9.9375 12.9375H12V10.875C12 10.5643 12.2518 10.3125 12.5625 10.3125Z", fill: "currentColor" })
    ]
  }
);
export {
  t as default
};
